<template>
  <div class="row pt-3" v-if="completedInterviews.length > 0">
    <div class="col">
      <ProfileSubSectionHeader title="Interviews" icon="interview-icon" />

      <div class="d-none d-md-block">
        <table class="table table-hover align-middle mt-3">
          <thead class="table-light">
            <tr>
              <th>Trade</th>
              <th>Submitted</th>
              <th>Score</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="interview in completedInterviews" :key="interview.id">
              <td class="fw-semibold">{{ interview.tradeId }}</td>
              <td>{{ formatDate(interview.submittedAt) }}</td>
              <td>
                {{ formatScore(interview.totalScore) }}
                <span class="text-muted">/&nbsp;10</span>
              </td>
              <td class="text-end">
                <DefaultButton
                  labelText="View"
                  :btnType="['view-btn']"
                  @click="viewInterview(interview.id)"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="d-md-none">
        <div
          v-for="interview in completedInterviews"
          :key="interview.id"
          class="card mb-3"
        >
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-start mb-2">
              <span class="fw-semibold">{{ interview.tradeId }}</span>
              <span>
                {{ formatScore(interview.totalScore) }}
                <span class="text-muted">/ 10</span>
              </span>
            </div>
            <p class="text-muted small mb-2">
              Submitted: {{ formatDate(interview.submittedAt) }}
            </p>
            <DefaultButton
              labelText="View"
              :btnType="['view-btn']"
              @click="viewInterview(interview.id)"
            />
          </div>
        </div>
      </div>
    </div>

    <DefaultModal
      id="candidate-interview-results-modal"
      title="Interview Results"
      description=""
      :showActions="false"
      @onClosed="selectedInterviewId = null"
    >
      <template v-slot:input>
        <InterviewResults
          v-if="selectedInterviewId"
          :interviewId="selectedInterviewId"
        />
      </template>
    </DefaultModal>
  </div>
</template>

<script>
import interviewApi from "@/api/interview"
import ProfileSubSectionHeader from "@/components/Profile/ProfileSubSectionHeader"
import InterviewResults from "@/components/Interview/InterviewResults.vue"
import DefaultModal from "@/components/Modals/DefaultModal"
import DefaultButton from "@/components/DefaultButton"

export default {
  name: "candidate-profile-interviews",
  components: {
    ProfileSubSectionHeader,
    InterviewResults,
    DefaultModal,
    DefaultButton,
  },
  props: {
    profile: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      interviews: [],
      selectedInterviewId: null,
    }
  },
  computed: {
    completedInterviews() {
      return this.interviews.filter(
        (interview) => interview.evaluationStatus === "complete"
      )
    },
  },
  async mounted() {
    try {
      const res = await interviewApi.listByProfile(this.profile._id)
      this.interviews = res.data.interviews ?? []
    } catch {
      this.interviews = []
    }
  },
  methods: {
    viewInterview(interviewId) {
      this.selectedInterviewId = interviewId
      this.$bvModal.show("candidate-interview-results-modal")
    },
    formatDate(dateStr) {
      if (!dateStr) return "—"
      return new Date(dateStr).toLocaleDateString(undefined, {
        year: "numeric",
        month: "short",
        day: "numeric",
      })
    },
    formatScore(score) {
      if (score == null) return "—"
      return Number(score).toFixed(1)
    },
  },
}
</script>
